import React from 'react'
import UiInputList from "../components/Form/UiInputList";
import UiInputDate from "../components/Form/UiInputDate";
import UIInputFile from "../components/Form/UIInputFile";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';
import { useNotification } from '../components/Core/NotificationProvider';

const papelList = [
    { id: 'instalador', title: 'Instalador' },
    { id: 'empresa', title: 'Empresa' },
    { id: 'socio', title: 'Sócio administrador' },
    { id: 'testemunha', title: 'Testemunha' },
];

/**
 * "Anexar assinado" do grid de contratos: o contrato assinado à mão, devolvido
 * escaneado. Registra a assinatura com tipo `upload_scan` e o SHA-256 do arquivo.
 *
 * O arquivo vai para `storage/contratos/`, que não é servido pela web: quem baixa é
 * a rota autenticada `uncontrato/form&action=arquivo`.
 */
export default function ContratoAssinaturaForm(props: any){
    const contrato = props.data || {};
    const versaoAtual = Number(contrato.versao_atual) || 0;

    const methods = useForm<any>({ defaultValues: { papel: 'instalador', assinadoEm: null, arquivo: null } });
    const { handleSubmit, watch } = methods;
    const notification = useNotification();

    const arquivo = watch('arquivo');

    const anexar = (dados: any) => {
        if (!dados.arquivo || !dados.arquivo.length) {
            notification.error('Anexe o arquivo do contrato assinado');
            return;
        }
        if (!dados.papel) {
            notification.error('Informe quem assinou');
            return;
        }

        props.triggerSubmit({
            contrato: { id: contrato.id },
            papel: dados.papel,
            assinadoEm: dados.assinadoEm || '',
            arquivo: dados.arquivo,
        });
    };

    if (versaoAtual < 1) {
        return (
            <>
                <WindowBody>
                    <div className="alert alert-warning">
                        Este contrato ainda não tem versão gerada. Use <b>Gerar versão</b> antes de anexar
                        o assinado: a assinatura é registrada sobre uma versão do documento.
                    </div>
                </WindowBody>
                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                </WindowFooter>
            </>
        );
    }

    return (
        <FormProvider {...methods}>
            <Form onSubmit={handleSubmit(anexar)} methods={methods}>
                <WindowBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="text-muted small">
                                Contrato <b>#{contrato.id}</b> &middot; {contrato['instalador/nome']}
                                <br/>
                                A assinatura entra na <b>versão {versaoAtual}</b>, que é a que está valendo.
                            </p>
                        </div>
                        <UiInputList size={6} name="papel" list={papelList} idField="id" titleField="title" label="Quem assinou" placeholder={false}/>
                        <UiInputDate size={6} name="assinadoEm" label="Assinado em (opcional)"/>
                        <UIInputFile size={12} name="arquivo" label="Contrato assinado (PDF ou imagem)"/>
                        {arquivo && arquivo.length ? null : (
                            <div className="col-lg-12">
                                <p className="text-muted small" style={{ margin: 0 }}>
                                    O arquivo é guardado fora da área pública e o SHA-256 dele fica registrado,
                                    para provar depois que o documento arquivado é o mesmo que foi assinado.
                                </p>
                            </div>
                        )}
                    </div>
                </WindowBody>

                <WindowFooter>
                    <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
                    <UiButton variant="primary" type="submit">Anexar</UiButton>
                </WindowFooter>
            </Form>
        </FormProvider>
    )
}
